import { getWhatsApp } from "./siteContent";
import { formatBRL } from "./format";
import type { CheckoutForm, OrderRecord } from "@/types";

export const waLink = (message: string): string =>
  `https://wa.me/${getWhatsApp().number}?text=${encodeURIComponent(message)}`;

const has = (value?: string): boolean => Boolean(value && value.trim());

export function buildOrderMessage(order: OrderRecord, form: CheckoutForm): string {
  const lines: string[] = [];

  lines.push("🛍️ NOVO PEDIDO | AURÉA — CALÇADOS & ACESSÓRIOS");
  lines.push(`Pedido: ${order.code}`);
  lines.push("");

  lines.push("👤 CLIENTE");
  lines.push(`Nome: ${form.name.trim()}`);
  lines.push(`WhatsApp: ${form.phone.trim()}`);
  if (has(form.email)) lines.push(`E-mail: ${form.email.trim()}`);
  lines.push("");

  lines.push("📦 PRODUTOS ESCOLHIDOS");
  lines.push("");
  order.items.forEach((item, index) => {
    lines.push(`${index + 1}. ${item.name}`);
    lines.push(`   Código: ${item.code}`);
    lines.push(`   Cor: ${item.colorName}`);
    lines.push(`   ${/^\d+$/.test(item.size) ? "Numeração" : "Tamanho"}: ${item.size}`);
    lines.push(`   Quantidade: ${item.quantity}`);
    lines.push(`   Valor unitário: ${formatBRL(item.unitPrice)}`);
    lines.push(`   Subtotal: ${formatBRL(item.subtotal)}`);
    lines.push("");
  });

  lines.push("🚚 RECEBIMENTO");
  lines.push(`Modalidade: ${order.deliveryLabel}`);

  if (order.deliveryMethodId === "onibus" && order.bus) {
    lines.push(`Cidade de destino: ${order.bus.destinationCity} — ${order.bus.destinationState}`);
    if (has(order.bus.terminal)) lines.push(`Ponto de retirada: ${order.bus.terminal.trim()}`);
    lines.push(`Responsável pela retirada: ${order.bus.responsibleName.trim()}`);
    lines.push(`Telefone do responsável: ${order.bus.responsiblePhone.trim()}`);
  } else if (order.address && order.deliveryMethodId !== "retirada") {
    const addr = order.address;
    if (has(addr.street)) lines.push(`Endereço: ${addr.street.trim()}, ${addr.number.trim()}`);
    if (has(addr.complement)) lines.push(`Complemento: ${addr.complement.trim()}`);
    if (has(addr.district)) lines.push(`Bairro: ${addr.district.trim()}`);
    if (has(addr.city)) lines.push(`Cidade: ${addr.city.trim()} — ${addr.state.trim().toUpperCase()}`);
    if (has(addr.cep)) lines.push(`CEP: ${addr.cep.trim()}`);
    if (has(addr.reference)) lines.push(`Referência: ${addr.reference.trim()}`);
  }

  lines.push(`Prazo apresentado: ${order.deliveryDeadline}`);
  lines.push(
    `Taxa: ${
      order.shippingFee === null
        ? "Taxa a confirmar"
        : order.freeShipping
          ? `${formatBRL(0)} (frete grátis)`
          : formatBRL(order.shippingFee)
    }`,
  );
  lines.push("");

  lines.push("💰 RESUMO");
  lines.push(`Quantidade de itens: ${order.itemCount}`);
  lines.push(`Produtos: ${formatBRL(order.subtotal)}`);
  lines.push(`Desconto: ${order.discount > 0 ? `-${formatBRL(order.discount)}` : formatBRL(0)}`);
  lines.push(
    `Frete: ${
      order.shippingFee === null
        ? "Taxa a confirmar"
        : order.freeShipping
          ? formatBRL(0)
          : formatBRL(order.shippingFee)
    }`,
  );
  lines.push(`Total estimado: ${formatBRL(order.total)}`);
  lines.push("");

  if (has(order.notes)) {
    lines.push("📝 OBSERVAÇÕES");
    lines.push(order.notes.trim());
    lines.push("");
  }

  lines.push(
    "A disponibilidade, o prazo, o frete e a forma de pagamento serão confirmados no atendimento.",
  );
  lines.push("");
  lines.push(getWhatsApp().orderSignature);

  return lines.join("\n");
}